// extracted by mini-css-extract-plugin
export default {"input":"SignUpPersonalForm_input__Dhmcx","errored":"SignUpPersonalForm_errored__dcJRO","error":"SignUpPersonalForm_error__Ze0VH","grid":"SignUpPersonalForm_grid__gUdgs"};